import { observer } from 'mobx-react-lite';
import { FC } from 'react';

import { useTranslation } from '@gem/modules/i18n';

import { CallAddSpeakerLink } from '../CallAddSpeakerLink/CallAddSpeakerLink';
import { CallSpeakerPermissionsItem } from '../CallSpeakerPermissionsItem/CallSpeakerPermissionsItem';
import { useCallSpeakerListBlockPresenter } from './CallSpeakerListBlock.presenter';
import styles from './CallSpeakerListBlock.styles.m.css';
import { ICallSpeakerListBlockProps } from './CallSpeakerListBlock.types';

export const CallSpeakerListBlock: FC<ICallSpeakerListBlockProps> = observer((props) => {
  const presenter = useCallSpeakerListBlockPresenter(props);
  const { t } = useTranslation();

  return (
    <>
      <div className={styles.blockName}>{t('webinar_permissions_section_title')}</div>
      <div className={styles.container}>
        <CallAddSpeakerLink
          call={props.call}
          activeSpeakersIds={presenter.activeSpeakersIds}
          callController={props.callController}
          popupInstance={props.popupInstance}
          onClose={props.onClose}
        />
        {presenter.activeSpeakersIds.length && (
          <>
            {presenter.activeSpeakersIds.map((id) => (
              <CallSpeakerPermissionsItem
                key={id}
                userId={id}
                call={props.call}
                callController={props.callController}
              />
            ))}
          </>
        )}
      </div>
    </>
  );
});
